export const azerbaijaniEnglishLettersKeyDown = (
  event: React.KeyboardEvent<HTMLInputElement>
): void => {
  // Allow navigation and control keys
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
  ];

  if (allowedKeys.includes(event.key)) {
    return;
  }

  // Allow English letters (a-z, A-Z), Azerbaijani letters (ə, ğ, ı, ö, ü, ş, ç and uppercase), numbers (0-9), dash (-), and space
  if (!/^[a-zA-Z0-9əöğçşüƏÖĞÇŞÜ\s'"-]*$/.test(event.key)) {
    event.preventDefault();
  }
};
